<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 17.404 17.616">
        <g id="test-tube_1_" data-name="test-tube (1)" transform="translate(0 -1.616)">
            <path id="Path_69821" data-name="Path 69821"
                  d="M10.909,64.335a1.143,1.143,0,0,0-1.617,1.617l.139.139L.953,74.568a3.254,3.254,0,0,0,4.6,4.6l8.478-8.478.139.138a1.143,1.143,0,0,0,1.617-1.617ZM5.133,78.748A2.657,2.657,0,0,1,1.375,74.99l1.436-1.436h7.516Zm9.847-8.179a.549.549,0,0,1-.386-.16l-.561-.561-3.109,3.109H3.408l1.071-1.071.685.685.422-.422L4.9,71.465l.474-.474,1.282,1.282.422-.422L5.8,70.569,6.27,70.1l.685.685.422-.422-.685-.685.474-.474,1.282,1.282.422-.422L7.588,68.777l.474-.474.685.685.422-.422-.685-.685.474-.474,1.282,1.282.422-.422L9.38,66.986l.474-.473,3.073,3.073.422-.422L9.714,65.529A.546.546,0,0,1,10.1,64.6a.549.549,0,0,1,.386.16l4.88,4.879a.546.546,0,0,1-.386.932Zm0,0"
                  transform="translate(0 -60.891)" fill="#fff"/>
            <path id="Path_69822" data-name="Path 69822"
                  d="M433.194,88a1.194,1.194,0,1,0,1.194,1.194A1.2,1.2,0,0,0,433.194,88Zm0,1.792a.6.6,0,1,1,.6-.6A.6.6,0,0,1,433.194,89.791Zm0,0"
                  transform="translate(-416.985 -84.549)" fill="#fff"/>
            <path id="Path_69823" data-name="Path 69823"
                  d="M320.9,25.792a.9.9,0,1,0-.9-.9A.9.9,0,0,0,320.9,25.792Zm0-1.194a.3.3,0,1,1-.3.3A.3.3,0,0,1,320.9,24.6Zm0,0"
                  transform="translate(-308.057 -22.384)" fill="#fff"/>
        </g>
    </svg>

</template>

<script>
    export default {
        name: "ITubeWhite",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
